import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { Link } from "react-router-dom";
import useSocket from "use-socket.io-client";
import {
  useAppEvenListSelector,
  useAppEventGameListSelector,
  useAppRodeoEventLoginRequiredSelector,
} from "src/_common/hooks/selectors/eventSelector";
import {
  CRYPTO_SECRET_KEY,
  getEventStatusText,
  URLS,
  SOCKET_URL,
  SOCKET_CHANNEL,
  INSIDERODEO_EVENT_STORAGE,
  RODEPICK_NEXT_GAME_IDS,
  SELECTED_EVENT_STORAGE,
} from "src/_config";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import { toast } from "react-toastify";
import { useAppEventAction } from "src/_common/hooks/actions/event/appEventActionHook";
import { useAppGuestUserIdSelector, useAppUserDetailsSelector } from "src/_common/hooks/selectors/userSelector";
import clsx from "clsx";
import VideoModal from "../modal/videoModal";
import Sponsor from "src/components/common/Sponsor";
import LeagueCodeModal from "../modal/leagueCodeModal";
import UpcomingRodeoEventComponent from "../rodeoEvent/upcomingRodeoEvent";
import moment from "moment";

const Cryptr = require("cryptr");
const cryptr = new Cryptr(CRYPTO_SECRET_KEY);

export default function RodeoEventPerformancePage() {
  const eventApi = useEventApi();
  const history = useHistory();
  const eventAction = useAppEventAction();
  const userDetails = useAppUserDetailsSelector();
  // const eventGameListSelector = useAppEventGameListSelector()
  const [loginReq, setLoginReq] = useState<any>(0);
  const { eventId } = useParams<any>();
  const e_id: number = parseInt(cryptr.decrypt(eventId));
  const eventListSelector = useAppEvenListSelector();
  const guestUserId = useAppGuestUserIdSelector();
  const [performanceList, setPerformanceList] = useState<any>();
  const [selectedPerformance, setSelectedPerformance] = useState<any>();
  const [responseDetails, setResponseDetails] = useState<any>();
  const [showVideoModal, setShowVideoModal] = useState<boolean>(false);
  const [showLeagueCodeModal, setShowLeagueCodeModal] = useState<boolean>(false);
  const [url, setUrl] = useState<any>("");
  const [promoType, setPromoType] = useState<any>("");
  const [socketData, setSocketData] = useState<any>();

  const isInsideRodeoTokenExists = localStorage.getItem(INSIDERODEO_EVENT_STORAGE);

  const [socket] = useSocket(SOCKET_URL, {
    autoConnect: false,
    transports: ['websocket', 'polling'], // Prefer websocket, fallback to polling
    upgrade: true,
    rememberUpgrade: true,
  });

  const getPerformanceList = () => {
    const params: any = {
      rodeo_event_id: e_id,
    };
    if (!userDetails) {
      if (guestUserId) {
        params["guest_user_id"] = guestUserId;
      }
    }
    eventApi.callPerformanceList(
      params,
      (message: string, resp: any) => {
        if (resp) {
          // eventAction.updateLoginRequired(resp.rodeo_event_dtls.login_required)
          setPerformanceList(resp?.performances);
          // console.log(resp)
          setResponseDetails(resp);
          setLoginReq(resp?.rodeo_event_dtls?.login_required || 0);
        }
      },
      (message: string) => {
        toast.error(message);
      }
    );
  };

  const goToGameDetailsPage = (e: any, game: number) => {
    e.preventDefault();
    const gameId = cryptr.encrypt(game);
    history.push(`/event/${eventId}/${gameId}`);
  };

  const goToGameListingPage = (e: any, performance: any) => {
    e.preventDefault();
    eventAction.setSiteHeader(responseDetails.rodeo_event_game_info.enable_header);
    eventAction.setStatusMsg(responseDetails.status);
    setSelectedPerformance(performance);
    if (
      performance?.is_enable_league_code != "1" ||
      (performance?.is_enable_league_code == "1" && performance?.league_code_details) ||
      !userDetails
    ) {
      checkPromoVid(performance);
    } else {
      let seen: any = checkLeagueModalSeen(performance);
      if (!seen) {
        openLeagueCodeModal();
      } else {
        checkPromoVid(performance);
      }
    }
  };

  const checkPromoVid = (performance: any) => {
    let seen: any = checkPromoVidSeen(performance);
    // console.log({seen})
    if (!seen) {
      let vid = performance?.sponsor;
      let type = vid?.file_mime.substring(0, vid?.file_mime?.indexOf("/"));
      setPromoType(type);
      setUrl(vid?.original);
      if (type == "video" || type == "image") {
        setShowVideoModal(true);
      } else {
        changePage(performance);
      }
    } else {
      changePage(performance);
    }
  };

  const checkPromoVidSeen = (performance: any) => {
    let x: any = localStorage.getItem("performanceVidSeen_" + performance?.id);
    // console.log({x})
    if (x && x == "1") {
      return true;
    } else {
      return false;
    }
  };

  const checkLeagueModalSeen = (performance: any) => {
    let x: any = localStorage.getItem("performanceLeagueSeen_" + performance?.id);
    // console.log({x})
    if (x && x == "1") {
      return true;
    } else {
      return false;
    }
  };

  const changePage = (performance: any) => {
    const performanceId = cryptr.encrypt(performance.id);
    if (
      responseDetails?.settings?.is_event_prize ||
      responseDetails?.settings?.is_performance_prize ||
      responseDetails?.settings?.is_game_prize
    ) {
      eventAction.rodeoEventSettings(responseDetails?.settings);
      if (
        !responseDetails?.settings?.is_event_prize &&
        !responseDetails?.settings?.is_performance_prize &&
        responseDetails?.settings?.is_game_prize
      ) {
        history.push(`/prize/${eventId}/${performanceId}/${cryptr.encrypt("Game")}`);
      } else {
        history.push(`/prizes/${eventId}/${performanceId}`);
      }
    } else {
      history.push(`/event/${eventId}/${performanceId}`);
    }
  };

  const closeVideoModal = () => {
    setTimeout(() => {
      setShowVideoModal(false);
      localStorage.setItem("performanceVidSeen_" + selectedPerformance?.id, "1");
      changePage(selectedPerformance);
    }, 1000);
  };

  const openLeagueCodeModal = () => {
    setShowLeagueCodeModal(true);
  };

  const closeLeagueCodeModal = () => {
    setShowLeagueCodeModal(false);
    checkPromoVid(selectedPerformance);
    localStorage.setItem("performanceLeagueSeen_" + selectedPerformance?.id, "1");
  };

  useEffect(() => {
    // if (userDetails) {
    socket.connect();

    //Status Change Socket
    socket.on(SOCKET_CHANNEL.START_EVENT, (changeEventStatus: any) => {
      eventAction.pushGameStatusChangeSocketDataIntoGameList(changeEventStatus);
    });

    //Status Message Change Socket
    socket.on(SOCKET_CHANNEL.START_STOP_RP_EVENT, (data: any) => {
      console.log({ data });
      setSocketData(data);
    });

    socket.on(SOCKET_CHANNEL.PERFORMANCE_STATUS_UPDATE, (data: any) => {
      console.log({ data });
      setSocketData(data);
      // getPerformanceList();
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    socket.connect();

    socket.on(SOCKET_CHANNEL.START_EVENT, (changeEventStatus: any) => {
      if (changeEventStatus && changeEventStatus.rodeo_event_id && guestUserId) {
        //   console.log(changeEventStatus.rodeo_event_id)
        // setShowGuestSaveVoteModal(true)
      }
    });

    return () => {
      socket.disconnect();
    };
  }, [socket]);

  useEffect(() => {
    getPerformanceList();
  }, []);

  useEffect(() => {
    if (userDetails || loginReq == 0) {
      // history.push(`/performances/${eventId}`)
    } else {
      localStorage.setItem("currentPage", `/performances/${eventId}`);
      history.push(`${URLS.LOGIN}`);
    }
  }, [loginReq]);

  useEffect(() => {
    if (performanceList && socketData) {
      let p = performanceList?.map((x: any) => {
        if (x.id == socketData.performance_id) {
          x["status"] = socketData.status;
        }
        return x;
      });
      console.log({ p });
      // let p = performanceList?.map((x: any) => {
      //   if (x.id == socketData?.performance?.id) {
      //     return socketData?.performance;
      //   }
      //   return x;
      // });
      setSocketData(null);
      setPerformanceList(p);
    }
  }, [performanceList, socketData]);

  return (
    <React.Fragment>
      {url && showVideoModal && promoType && (
        <VideoModal onClose={closeVideoModal} url={url} shouldShow={showVideoModal} type={promoType} />
      )}

      {showLeagueCodeModal && selectedPerformance && (
        <LeagueCodeModal
          onClose={closeLeagueCodeModal}
          shouldShow={showLeagueCodeModal}
          rodeoEventId={e_id + ""}
          performanceId={selectedPerformance?.id}
        />
      )}
      <div className="main-content-panel">
        <UpcomingRodeoEventComponent />

        <h1>Performances</h1>

        <div className="events-list-panel">
          {performanceList?.filter((p: any) => p?.status == 1)?.length ? (
            performanceList
              .filter((p: any) => p?.status == 1)
              .map((performance: any) => (
                <div
                  key={performance?.id}
                  className={
                    "events-list-block d-flex align-items-center " + (performance?.rp_start_pick ? "glow" : "")
                  }
                  // className={clsx({
                  //   "ripple-effect not-started-yet d-flex": performance?.status === 0,
                  //   "ripple-effect on-going-game d-flex": performance?.status === 1,
                  //   "ripple-effect event-end d-flex": performance?.status === 2,
                  // })}
                  onClick={(e) => goToGameListingPage(e, performance)}
                >
                  <div className="events-icon d-flex justify-content-center">
                    <img
                      src={performance?.avatar?.id != 0 ? performance?.avatar?.original : "/images/no-image.png"}
                      alt={`event-${performance?.title}`}
                    />
                  </div>
                  <div className="events-list-content">
                    <h4>{performance?.title}</h4>
                    <p>{performance?.pdate ? moment(performance?.pdate).format("MMM DD, YYYY") : ""}</p>
                  </div>
                </div>
              ))
          ) : (
            <div className={"events-list-block d-flex align-items-center"}>
              <div className="team-list-content">
                <h4>No performances available</h4>
              </div>
            </div>
          )}
        </div>
      </div>

      <Sponsor />
    </React.Fragment>
  );
}
